import React from "react";
import api from "../../Api/apiAxios";
import { useNavigate, useParams } from "react-router-dom";
import Loading from "../../Components/Loading";
import { MyContext } from "../../Context/MyContext";
import Mensagem from "../../Components/Mensagem";
import { Button, Form, Row, Col, FloatingLabel, Alert } from "react-bootstrap";
import ModalNS from "../../Components/ModalNS";
import styles from "./EditarServico.module.css";

const EditarServico = () => {
    const { id } = useParams();

    const navigate = useNavigate();

    var RegexValorDecimal = /[0-9]{1,3}[, ]*[0-9]{0,2}/;

    const nivelUsuario = window.localStorage.getItem('nivelUsuario');  

    const { mensagemGlobal, setMensagemGlobal, setTipoMensagemGlobal, tipoMensagemGlobal } = React.useContext(MyContext);

    const [loading, setLoading] = React.useState(false);

    const [distribuidorId, setDistribuidorId] = React.useState('');
    const [clienteId, setClienteId] = React.useState('');
    const [usuarioId, setUsuarioId] = React.useState('');
    const [razaoSocialDistribuidor, setRazaoSocialDistribuidor] = React.useState('');
    const [razaoSocialCliente, setRazaoSocialCliente] = React.useState('');
    const [sistema, setSistema] = React.useState('');
    const [valorServico, setValorServico] = React.useState(0);
    const [valorParcela, setValorParcela] = React.useState(0);
    const [quantidadeParcelas, setQuantidadeParcelas] = React.useState('');
    const [descricaoServico, setDescricaoServico] = React.useState('');
    const [dataInclusao, setDataInclusao] = React.useState('');
    const [dataEditada, setDataEditada] = React.useState('');
    const [ressarcimento, setRessarcimento] = React.useState(false);
    const [integrarMesAnterior, setIntegrarMesAnterior] = React.useState('');
    const [statusMesAnterior, setStatusMesAnterior] = React.useState(false);
    const [distribuidores, setDistribuidores] = React.useState([]);
    const [clientes, setClientes] = React.useState([]);
    const [tiposServicos, setTiposServicos] = React.useState([]);
    const [tipoServico, setTipoServico] = React.useState('');
    const [observacaoNotaFiscal, setObservacaoNotaFiscal] = React.useState('');
    const [numeroSerie, setNumeroSerie] = React.useState('');
    const [listaNS, setListaNS] = React.useState([]);
    const [showModalNS, setShowModalNS] = React.useState(false);
    const [nsSelecionada, setNsSelecionada] = React.useState(false);
    const isFirstRender = React.useRef(true);

    const idDistribuidor = window.localStorage.getItem('distribuidorId');

    async function loadClientes(id) {
      const response = await api.get(`/Cliente/${id}/A`);
      response.data.sort((a, b) => a.razaoSocial.localeCompare(b.razaoSocial));
      setClientes(response.data);
    }

    function getValueDistribuidor(ev) {
      const idSelected = ev.target.children[ev.target.selectedIndex].getAttribute('id');
      setDistribuidorId(idSelected);
      const texto = ev.target.options[ev.target.selectedIndex].text;
      setRazaoSocialDistribuidor(texto);

      loadClientes(idSelected);
      setClienteId('');
      setRazaoSocialCliente('');
    }

    function getValueCliente(ev) {
      const idClienteSelected = ev.target.children[ev.target.selectedIndex].getAttribute('id');
      setClienteId(idClienteSelected);
      const texto = ev.target.options[ev.target.selectedIndex].text;
      setRazaoSocialCliente(texto);
    }

    React.useEffect(() => {
      async function fetchTiposServicos() {
        try {
          const resp = await api.get('/TipoServico');
          setTiposServicos(Array.isArray(resp.data) ? resp.data : []);
        } catch (e) {
          console.log('Erro ao buscar tipos de serviço:', e);
          setTiposServicos([]);
        }
      }
      fetchTiposServicos();
    }, []);

    React.useEffect(() => {
      async function pesquisarDistribuidores() {
        setLoading(true);
        const response = await api.get('/Distribuidor');

        if (nivelUsuario !== "1") {
          const filtrados = response.data.filter((d) => d.id.toString().includes(idDistribuidor));
          setDistribuidores(filtrados);
        } else {
          setDistribuidores(response.data);
        }
        setLoading(false);
      }

      pesquisarDistribuidores();
    }, []);

    React.useEffect(() => {
        const data = new Date();
        const dia = data.getDate();     
        if  (dia > 25)
            setStatusMesAnterior(false)
        else
            setStatusMesAnterior(true);    
    
        async  function pesquisar() { 
               setLoading(true);                  
               const response = await api.get(`/Servico/${id}`);    

               setDescricaoServico(response.data.descricaoServico);
               setValorServico(response.data.valorServico);
               setQuantidadeParcelas(response.data.quantidadeParcelas);
               setValorParcela((Number(valorServico) / Number(quantidadeParcelas)).toFixed(2));               
               setDataInclusao(response.data.dataInclusao);      
               
               setDistribuidorId(response.data.distribuidorId);
               setClienteId(response.data.clienteId);
               setUsuarioId(response.data.usuarioId);
               setRazaoSocialCliente(response.data.cliente.razaoSocial);
               setRazaoSocialDistribuidor(response.data.distribuidor.razaoSocial);
               setSistema(response.data.tipoSistema);
               setTipoServico(response.data.tipoServico || '');
               setObservacaoNotaFiscal(response.data.observacaoNotaFiscal || '');
               setNumeroSerie(response.data.numeroSerie || '');


               if  (response.data.ressarcimento === 1) {
                    setRessarcimento(true)
               }
               else setRessarcimento(false);     

               if  (response.data.integrarMesAnterior === 1) {
                    setIntegrarMesAnterior(true)
               }
               else setIntegrarMesAnterior(false);     

               const dataString = response.data.dataInclusao.substring(8,10) + "/" +
                                  response.data.dataInclusao.substring(5,7)  + "/" +   
                                  response.data.dataInclusao.substring(0,4);
               setDataEditada(dataString);                                   
               
               await loadClientes(response.data.distribuidorId);

               setLoading(false);       
        }

        pesquisar();            

    }, []);    

    React.useEffect(() => {
        if  (quantidadeParcelas)
        {
            setValorParcela((Number(valorServico) / Number(quantidadeParcelas)).toFixed(2));
        }
    }, [quantidadeParcelas]);

    const endpointNS = { '1': 'LicencaPonto', '2': 'LicencaAcesso' };

    async function loadNumeroSerie(clienteId, sistema) {
        const endpoint = endpointNS[String(sistema)];
        if (!endpoint || !clienteId) return;
        try {
            const res = await api.get(`/${endpoint}/retornar-ns-cliente?id=${clienteId}`);
            const lista = (res.data || []).filter(l => l.numeroSerie);
            if (lista.length === 0) return;
            if (lista.length === 1) {
                setNumeroSerie(lista[0].numeroSerie);
            } else {
                setListaNS(lista);
                setShowModalNS(true);
            }
        } catch (e) {
            console.log('Erro ao buscar NS:', e);
        }
    }

    React.useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        setNumeroSerie('');
        setListaNS([]);
        setNsSelecionada(false);
        if (clienteId && sistema) {
            loadNumeroSerie(clienteId, sistema);
        }
    }, [clienteId, sistema]);

    async function handleSubmit(ev) {
        ev.preventDefault();
        setMensagemGlobal(null);

        var valido = RegexValorDecimal.test(Number(valorServico));
        if (!valido) {
            setMensagemGlobal("Valor inválido. Utilize somente numeros e ponto decimal para centavos !");
            setTipoMensagemGlobal("danger");
            return;
        }

        if  (quantidadeParcelas.length === 0) {
            setMensagemGlobal("Faltou Definir a quantidade de parcelas...");
            setTipoMensagemGlobal("danger");
            return;
        }

        if (!tipoServico) {
          setMensagemGlobal("Faltou selecionar o Tipo de Serviço");
          setTipoMensagemGlobal("danger");
          return;
        }

        const dataAtual = new Date();       
        let regServico = {
            Id: Number(id),
            DistribuidorId: Number(distribuidorId),                        
            ClienteId: Number(clienteId),
            UsuarioId: Number(usuarioId),
            TipoSistema: Number(sistema),
            TipoServico: Number(tipoServico || 0),
            DescricaoServico: descricaoServico,
            QuantidadeParcelas: Number(quantidadeParcelas),
            StatusServico: 0,
            ValorServico: Number(valorServico),
            DataInclusao: dataInclusao,
            DataLiberacao: dataAtual,
            Ressarcimento: ressarcimento ? 1 : 0,
            IntegrarMesAnterior: integrarMesAnterior ? 1: 0,
            ObservacaoNotaFiscal: observacaoNotaFiscal || null,
            NumeroSerie: numeroSerie ? Number(numeroSerie) : null,

        }
               
        const ret = await api.put("Servico/", 
                    JSON.stringify(regServico), 
              {
                  headers: { 'Content-Type': 'application/json'}
              });

        setMensagemGlobal(ret.data);
        setTipoMensagemGlobal("success");               
        navigate("/servicos");

    }


    if  (loading) return <Loading />

    return (
        <section className={styles.form}>
            {mensagemGlobal && <Mensagem mensagem={mensagemGlobal} setMensagem={setMensagemGlobal} variant={tipoMensagemGlobal} /> }

            {showModalNS && listaNS.length > 0 && (
                <ModalNS
                    modalNS={showModalNS}
                    setModalNS={setShowModalNS}
                    numeroSerie={numeroSerie}
                    setNumeroSerie={setNumeroSerie}
                    titleModal="Selecione o Número de Série"
                    listaNS={listaNS}
                    setNSSelecionada={setNsSelecionada}
                />
            )}

            <Alert style={{background: 'ghostwhite', color: 'black'}}>
                <Alert.Heading style={{textAlign: 'center'}}>Editar Serviço</Alert.Heading>        
            <br />  

            <Row className="g-2" style={{marginBottom: '1rem'}}> 
                <Col md='3'>
                    <FloatingLabel controlid="floatingInputGrid3" label="Tipo de Sistema">
                        <Form.Select value={sistema} onChange={({target}) => setSistema(target.value)}>
                            <option value="" disabled></option>
                            <option value="1">BmaPonto</option>
                            <option value="2">BmaAcesso</option>
                            <option value="3">BmaFolha</option>
                            <option value="4">SisDm</option>
                        </Form.Select>
                    </FloatingLabel>                    
                </Col>

                <Col md='9'>
                      {nivelUsuario === '1' ? (
                        <FloatingLabel controlid="floatingInputGrid" label="Revenda">
                          <Form.Select onChange={getValueDistribuidor} className="form-select-control">
                            <option></option>
                            {distribuidores.map((distribuidor) => (
                              <option
                                key={distribuidor.id}
                                id={distribuidor.id}
                                value={distribuidor.id}
                                selected={Number(distribuidorId) === Number(distribuidor.id)}
                              >
                                {distribuidor.razaoSocial}
                              </option>
                            ))}
                          </Form.Select>
                        </FloatingLabel>
                      ) : (
                        <FloatingLabel controlid="floatingInputGrid" label="Revenda">
                          <Form.Control
                            placeholder="Release"
                            value={razaoSocialDistribuidor}
                            disabled
                            onChange={({ target }) => setRazaoSocialDistribuidor(target.value)}
                          />
                        </FloatingLabel>
                      )}            
                </Col>
            </Row>

            <Row className="g-2" style={{marginBottom: '1rem'}}>    
                <Col md='3'>
                    <FloatingLabel controlid="floatingInputGrid2" label="Data Inclusão">
                        <Form.Control placeholder="Release" value={dataEditada} disabled
                                      onChange={({ target }) => setDataEditada(target.value)}/>             
                    </FloatingLabel>                  
                </Col>

                <Col md='6'>
                    {nivelUsuario === '1' ? (
                      <FloatingLabel controlid="floatingInputGrid2" label="Cliente">
                        <Form.Select onChange={getValueCliente} className="form-select-control">
                          <option></option>
                          {clientes.map((cliente) => (
                            <option
                              key={cliente.id}
                              id={cliente.id}
                              value={cliente.id}
                              selected={Number(clienteId) === Number(cliente.id)}
                            >
                              {cliente.razaoSocial} - {cliente.numeroInscricao}
                            </option>
                          ))}
                        </Form.Select>
                      </FloatingLabel>
                    ) : (
                      <FloatingLabel controlid="floatingInputGrid2" label="Cliente">
                        <Form.Control
                          placeholder="Release"
                          value={razaoSocialCliente}
                          disabled
                          onChange={({ target }) => setRazaoSocialCliente(target.value)}
                        />
                      </FloatingLabel>
                    )}              
                </Col>
                <Col md='3'>
                    <FloatingLabel controlid="floatingInputNS" label="Número de Série">
                        <Form.Control
                            placeholder="Número de Série"
                            value={numeroSerie || ''}
                            onChange={({ target }) => setNumeroSerie(target.value)}
                        />
                    </FloatingLabel>
                </Col>
            </Row>

            <Row className="g-2" style={{ marginBottom: '1rem' }}>
              <Col md="12">
                <FloatingLabel controlid="floatingInputGridTS" label="Tipo de Serviço">
                  <Form.Select
                    value={tipoServico}
                    onChange={({ target }) => setTipoServico(target.value)}
                    disabled={nivelUsuario !== '1'}
                  >
                    <option value="" disabled></option>
                    {tiposServicos.map((tipo) => (
                      <option key={tipo.id} value={tipo.id}>
                        {tipo.tituloTipo}
                      </option>
                    ))}
                  </Form.Select>
                </FloatingLabel>
              </Col>
            </Row>


            <Row className="g-2" style={{marginBottom: '1rem'}}>
                <Col md='4'>
                    <FloatingLabel controlid="floatingInputGrid6" label="Valor Serviço">
                        <Form.Control placeholder="Val.Servico" value={valorServico}
                                    onChange={({ target }) => setValorServico(target.value)}/>
                    </FloatingLabel>
                </Col>

                <Col md='4'>
                    <FloatingLabel controlid="floatingInputGrid3" label="Quantidade de Parcelas">
                        <Form.Select value={quantidadeParcelas} onChange={({target}) => setQuantidadeParcelas(target.value)}>
                            <option value="" disabled></option>
                            <option value="1">01</option>
                            <option value="2">02</option>
                            <option value="3">03</option>
                            <option value="4">04</option>
                            <option value="5">05</option>
                            <option value="6">06</option>
                            <option value="7">07</option>
                            <option value="8">08</option>
                            <option value="9">09</option>
                            <option value="10">10</option>
                        </Form.Select>
                    </FloatingLabel>                    
                </Col>

                <Col md='4'>
                    <FloatingLabel controlid="floatingInputGrid6" label="Valor Parcela">
                        <Form.Control placeholder="Val.Servico" value={valorParcela} disabled
                                    onChange={({ target }) => setValorParcela(target.value)}/>
                    </FloatingLabel>      
                </Col>

            </Row>

            <Row className="g-2" style={{marginBottom: '1rem'}}>
                <Col md='12'>
                    <FloatingLabel controlid="floatingInputGrid6" label="Descrição do Serviço">
                        <Form.Control placeholder="Descrição Serviço" value={descricaoServico} 
                                    onChange={({ target }) => setDescricaoServico(target.value)}/>
                    </FloatingLabel>      
                </Col>
            </Row>

            <Row className="g-2" style={{marginBottom: '0.25rem'}}>
                <Col md='12'>
                    <FloatingLabel controlid="floatingInputObsNF" label="Observação de NF">
                        <Form.Control
                            as="textarea"
                            placeholder="Observação de NF"
                            value={observacaoNotaFiscal}
                            maxLength={1000}
                            style={{ height: '80px' }}
                            onChange={({ target }) => setObservacaoNotaFiscal(target.value)}
                        />
                    </FloatingLabel>
                    <Form.Text className="text-muted">
                        Este texto será incluído nas observações da nota fiscal gerada no SISDM ({observacaoNotaFiscal.length}/1000)
                    </Form.Text>
                </Col>
            </Row>

            <Row className="g-2" style={{marginBottom: '1rem'}}>
                <Col md='12'>
                    <Form.Check
                        type="switch"
                        id="status-servico"
                        label="Assinale se o Serviço for de Ressarcimento a Revenda"                      
                        onChange={() => setRessarcimento(!ressarcimento)}
                        checked={ressarcimento}
                    />
                </Col>
            </Row>

            <Row className="g-2" style={{marginBottom: '1rem'}}>
                <Col md='12'>
                    <Form.Check 
                        type="switch"
                        id="integrar-servico-mes-ant"
                        label="Assinale para integrar o Serviço no faturamento anterior (somente para OS´s com data entre 26 e 31)"                      
                        onChange={() => setIntegrarMesAnterior(!integrarMesAnterior)}
                        checked={integrarMesAnterior}
                        disabled={statusMesAnterior}
                    />
                </Col>
            </Row>

            </Alert>

            <div className={styles.areaBtn}>                
               <Button onClick={handleSubmit} variant="outline-primary" className={styles.btn} 
                       disabled={nivelUsuario !== "1"}>Atualizar
               </Button>
               <Button onClick={() => navigate(-1)} variant="outline-info" className={styles.btn}>Voltar</Button>
            </div>    

        </section>
    )

}

export default EditarServico;